<script setup>
import {checkDataElement} from '../../apps/base';
import {computed, onMounted} from "vue";

const emits = defineEmits(['change']);
const model = defineModel();
const props = defineProps({
    name: {
        type: String,
        default: ''
    },
    options: Array,
    dataElement: String,
    dataElementPrefix: String,
    value: [String, Number],
    disabled: Boolean,
    readonly: Boolean,
    size: String,
    error: [String, Boolean]
});

onMounted(() => {
    if (Array.isArray(props.options) && props.options.length > 0 && !model.value) {
        model.value = props.options[0].value;
    }
});

const selectName = computed(() => {
    return props.name
});
const wrapClasses = computed(() => {
    let classes = [];

    if (props.error && !props.disabled) {
        classes.push('has-error');
    }

    if (model.value !== null && model.value !== undefined) {
        if (('' + model.value) !== '') {
            classes.push('has-value');
        }
    }

    return classes
});
const selectClasses = computed(() => {
    let classes = [];

    if (props.size) {
        classes.push(props.size);
    }

    return classes
});

</script>

<template>
    <div class="form-group" :class="wrapClasses">
        <select
            :name="selectName"
            v-model="model"
            :class="selectClasses"
            :disabled="disabled"
            :readonly="readonly"
            @change="emits('change', $event.target.value)"
            :data-element="checkDataElement(dataElement ? dataElement : dataElementPrefix + 'select-' + name)"
        >
            <option
                v-for="(option, key) in options"
                :key="key"
                :value="option.value"
                :selected="value == option.value"
                :data-element="checkDataElement(dataElementPrefix + 'option-' + name + '-'+option.value)"
            >

                {{ option.title }}
            </option>
        </select>
    </div>
</template>

<script>
export default {
    name: "FieldSelect",
}
</script>